export enum SentimentThreshold {
  Negative = -0.6,
  Neutral = 0.3,
  Positive = 1
}
